/**
 * 审批操作人展示名：优先 RejectByName（账号 PersonName/DisplayName），
 * RejectBy 为 AccountUserId；GUID / "AI" 显示为 AI。
 */
export function resolveApprovalRejectByActor(source) {
  if (!source || typeof source !== 'object') return '';
  const name = String(source.rejectByName ?? source.RejectByName ?? '').trim();
  if (name) return name;
  const by = String(source.rejectBy ?? source.RejectBy ?? '').trim();
  if (!by) return '';
  if (by.length >= 40 || /^AI$/i.test(by)) return 'AI';
  return by;
}
